module.exports = __webpack_public_path__ + "61ee608742b20d51fa0d531d36134a11.svg";